import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import BottomNav from "@/components/BottomNav";
import api from "@/lib/api";
import { ArrowLeft, Award, Lock } from "lucide-react";

export default function Badges() {
  const navigate = useNavigate();
  const [data, setData] = useState({ earned: [], all: [] });

  useEffect(() => {
    api.get("/badges/me").then((r) => setData(r.data));
  }, []);

  return (
    <MobileShell>
      <header className="px-6 pt-8 pb-4">
        <button onClick={() => navigate(-1)} className="text-slate-500 mb-3" data-testid="back-btn"><ArrowLeft size={20} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600">Milestones</p>
        <h1 className="text-2xl font-bold font-display text-slate-900 mt-1">Badges</h1>
      </header>

      <ul className="px-6 grid grid-cols-2 gap-3" data-testid="badge-list">
        {data.all.map((b) => (
          <li
            key={b.code}
            data-testid={`badge-${b.code}`}
            className={`rounded-2xl p-4 border ${b.earned ? "bg-teal-50 border-teal-100" : "bg-white border-slate-100"}`}
          >
            <div
              className={`w-12 h-12 rounded-full grid place-items-center ${
                b.earned ? "bg-teal-600 text-white" : "bg-slate-100 text-slate-400"
              }`}
            >
              {b.earned ? <Award size={22} /> : <Lock size={20} />}
            </div>
            <div className="mt-3 font-semibold text-slate-900 text-sm">{b.title}</div>
            <div className="text-xs text-slate-500 mt-0.5">{b.description}</div>
          </li>
        ))}
      </ul>
      <BottomNav />
    </MobileShell>
  );
}
